{
  "REPORTS": {
    "REPORTS": "Informes",
    "GENERATE_REPORT": "Generar informe",
    "NO_REPORT_SELECTED": "Ningún informe seleccionado...",
    "GENERATING_REPORT": "Generando informe",
    "ERROR_WHEN_GENERATING": "Error en la generación",
    "SEARCH": "Buscar..."
  }
}